export default __webpack_public_path__ + "a9a655f677841c93b2f39bde49b1b568.png";